<template>
  <div id="employee-new-modal">
    <vs-popup class="popup80" :title="title" :active.sync="localShow">

      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full mt-2">
          <label class="vs-input--label">Exame</label>
          <v-select class="vue_select_drop_size_200" v-model="scheduleTimes.schedule_type" :clearable="false"
            data-vv-as="Tipo de Exame" v-validate.initial="'required'" name="schedule_type"
            :reduce="option => option.value" placeholder="Selecione"
            :options="[ { value: 'psychotechnical',  label: 'Exame Psicotécnico' },
                        { value: 'theoretical_exam', label: 'Exame Teórico' },
                        { value: 'medical_exam',     label: 'Exame Médico' },
                        { value: 'practical_exam',   label: 'Exame Prático' }]" :dir="$vs.rtl ? 'rtl' : 'ltr'">
            <template #no-options="{}">
              Desculpe, nenhum resultado encontrado.
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('schedule_type')">{{ errors.first('schedule_type') }}</span>
        </div>

        <div class="vx-col md:w-1/4 w-full mt-2">
          <label class="vs-input--label">Dia da Semana</label>
          <v-select class="vue_select_drop_size_200" v-model="scheduleTimes.weekdays" :clearable="false"
            data-vv-as="Tipo de Exame" v-validate.initial="'required'" name="weekdays"
            :reduce="option => option.value" placeholder="Selecione"
            :options="[ { value: 1, label: 'Segunda Feira' },
                        { value: 2, label: 'Terça Feira' },
                        { value: 3, label: 'Quarta Feira' },
                        { value: 4, label: 'Quinta Feira' },
                        { value: 5, label: 'Sexta Feira' },
                        { value: 6, label: 'Sábado' }]" :dir="$vs.rtl ? 'rtl' : 'ltr'">
            <template #no-options="{}">
              Desculpe, nenhum resultado encontrado.
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('weekdays')">{{ errors.first('weekdays') }}</span>
        </div>

        <div class="vx-col md:w-1/4 w-full mt-2">
          <vs-input type="time" v-model="scheduleTimes.start_time" class="w-full" label="Início" data-vv-as="Início" v-validate.initial="'required'" name="start_time" />
          <span class="text-danger text-sm" v-show="errors.has('start_time')">{{ errors.first('start_time') }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
          <vs-input type="time" v-model="scheduleTimes.end_time" class="w-full" label="Fim" data-vv-as="Fim" v-validate.initial="'required'" name="end_time" />
          <span class="text-danger text-sm" v-show="errors.has('end_time')">{{ errors.first('end_time') }}</span>
        </div>
      </div>

      <vs-divider></vs-divider>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save" :disabled="!validateForm">Cadastrar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="secondary" @click="cancel">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    show: {
      Boolean, default: false
    },
    title: {
      String, default: 'Diálogo'
    }
  },

  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },

  data () {
    return {
      localShow: false,
      scheduleTimes: {
        schedule_type: null,
        weekdays: null,
        start_time: null,
        end_time: null
      }
    }
  },

  watch: {
    show (val) {
      this.localShow = val
    },
    localShow (val) {
      if (!val) {
        this.scheduleTimes = {
          schedule_type: null,
          weekdays: null,
          start_time: null,
          end_time: null
        }
        this.$emit('cancel')
      }
    }
  },

  methods: {
    action () {
      this.$emit('action')
    },
    cancel () {
      this.$emit('cancel')
    },
    async save () {
      try {
        this.$vs.loading()
        // SALVA NO BANCO
        const payload = {
          weekdays: [`${this.scheduleTimes.weekdays} ${this.scheduleTimes.start_time} ${this.scheduleTimes.end_time}`], // ARRAY 0 dom ... 6 sáb
          specific_days: [],
          schedule_type: this.scheduleTimes.schedule_type
        }
        const resp = await this.$store.dispatch('scheduleTime/store', payload)

        this.$store.commit('scheduleTime/UPDATE_SCHEDULE_TIMES', resp.data) // ADICIONO UM NOVO HORÁRIO E ATUALIZO O STATE
        this.$vs.loading.close()
        this.$vs.notify({
          time: 5000,
          title: 'SUCESSO',
          text: 'Dados Salvos.',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
        this.localShow = false
      } catch (error) {
        this.$vs.loading.close()
        if (error.response.status === 412) {
          this.$vs.notify({
            time: 5000,
            title: 'AVISO',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        } else {
          this.$vs.notify({
            time: 5000,
            title: 'Erro',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      }
    }
  }
}
</script>

<style>
  hr {
    margin-top: 2px;
    border: none;
    height: 1px;
    /* Set the hr color */
    color: rgb(204, 204, 204); /* old IE */
    background-color: rgb(204, 204, 204); /* Modern Browsers */
  }

  .popup80 .vs-popup {
    width: 80% !important;
  }

  .vue_select_drop_size_200 .vs__dropdown-menu {
    max-height: 200px;
  }
</style>
